(function() {
'use strict';

angular
    .module('TR')
    .config(config);

function config($provide, $httpProvider) {
    $provide.factory('errInterceptor', errInterceptor);

    errInterceptor.$inject = ['$location', '$q', 'commonErrors'];

    function errInterceptor($location, $q, commonErrors) {
        const _errCallbacksCollection = {};
        const googlebot = /googlebot/i.test(navigator.userAgent);
        const prerender = /prerender/i.test(navigator.userAgent);
        let _counter = 0;

        const service = {
            addErrCallback,
            responseError
        };


        function logError(data) {
            if (googlebot || prerender) {
                return;
            }

            const utm = JSON.parse($('body').attr('user')).UtmId;
            $.ajax({
                type: 'POST',
                url: 'website/logging/log',
                contentType: 'application/json',
                data: JSON.stringify({
                    Message: `Customer ended up on the error page with error: ${JSON.stringify({
                        utmId: utm,
                        userAgent: navigator.userAgent,
                        status: data.status,
                        url: data.config.url,
                        data: data.config.data
                    })}`,
                    LogLevel: 1 // Warning
                })
            });
        }

        // Basic error handling
        function _defaultError(data) {
            if (data.status === -1) {
                return;
            }

            $location.replace();
            // $location.path('error');
            logError(data);
        }

        // Retrieves submitted custom callback
        function _getCustomCallback(headers) {
            const _callbackName = headers['x-callback'] || '';
            return _errCallbacksCollection[_callbackName];
        }

        // Tries to invoke custom callback
        function _invokeCustomCallback(data) {
            if (!data.config) {
                return false;
            }

            const _errCallback = _getCustomCallback(data.config.headers);

            // no custom callback available
            if (!_errCallback || data.status === 401) {
                return false;
            }

            // dealing with partial callbacks
            if (typeof _errCallback === 'object') {
                if (!_errCallback[data.status]) {
                    return false;
                }
                _errCallback[data.status](data);
            } else if (typeof _errCallback === 'function') {
                // dealing with full callbacks
                _errCallback(data);
            } else {
                // dealing with weird things
                return false;
            }

            return true;
        }


        function addErrCallback(cb) {
            _errCallbacksCollection[++_counter] = cb;
            return _counter;
        }

        const callbacksHandled = {};

        function responseError(data) {
            //a hack to make sure that we don't handle the same error twice which can happen with the retry interceptor
            if (callbacksHandled[data.config.headers['x-callback']]) {
                return $q.reject(data);
            }
            callbacksHandled[data.config.headers['x-callback']] = true;

            if (!_invokeCustomCallback(data)) {
                // common error handling
                (commonErrors[data.status] || _defaultError)(data);
            }

            return $q.reject(data);
        }

        return service;
    }

    if ($httpProvider.interceptors.indexOf('errInterceptor') < 0) {
        $httpProvider.interceptors.unshift('errInterceptor');
    }
}
})();
